import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorStore } from '@stores';
import { Clipboard } from '@angular/cdk/clipboard';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatIconModule } from '@angular/material/icon';
import { FeedbackDialogComponent } from 'src/app/shared/feedback-dialog/feedback-dialog.component';


@Component({
  selector: 'error-dialog',
  templateUrl: './error-dialog.component.html',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconModule,
    TextFieldModule
  ],
})
export class ErrorDialogComponent {
  errorStore = inject(ErrorStore);

  private readonly clipboard = inject(Clipboard);
  private readonly dialogRef = inject(MatDialogRef<ErrorDialogComponent>);
  private readonly dialog = inject(MatDialog);

  onCopyErrors() {
    this.clipboard.copy(this.errorStore.errors().join('\n'));
  }

  onClear() {
    this.errorStore.clear();
  }

  onReport() {
    this.dialogRef.close();
    const errorsText = this.errorStore.errors().map(e => this.escapeHtml(e)).join('<br/>');
    this.dialog.open(FeedbackDialogComponent, {
      width: '600px',
      data: { type: 'Error', description: `<p><strong>Error reported:</strong></p><p>${errorsText}</p>` }
    });
  }

  private escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
}
